module.exports = __webpack_public_path__ + "img/video-player/yay@2x-332f80bf41f4608015d3880a2d6f68d1.png";